import styles from './ProtectedRoute.module.scss';
import { useMeQuery } from '@casops/store/apis/authApi';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@casops/store/hooks';
import { Permission, userHasPermission } from '@casops/permissions';
import { ProgressIndicatorCircular } from '@dmc/ui';
import { Navigate } from 'react-router-dom';
import { ReactElement } from 'react';

export interface ProtectedRouteProps {
  permission?: Permission;
  children: ReactElement;
}

export default function ProtectedRoute(props: ProtectedRouteProps) {
  const { t } = useTranslation();

  // useMeQuery only used to trigger redirections
  useMeQuery();
  const userData = useAppSelector(state => state.auth);

  const permission = props.permission ?? Permission.Viewer;

  if (userData.isRedirecting) {
    return (
      <div className={styles.loadingPanel}>
        <ProgressIndicatorCircular />
        <span>{userData.actionLoggingIn ? t('SigningIn') : t('SigningOut')}</span>
      </div>
    );
  }

  if (userHasPermission(userData, permission)) {
    return props.children;
  }

  return <Navigate to="/no-access" replace />;
}
